import script from "./AdventCalender.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdventCalender.vue?vue&type=script&lang=ts&setup=true"

import "./AdventCalender.vue?vue&type=style&index=0&id=2e14b0a4&lang=scss"

const __exports__ = script;

export default __exports__